import { render, staticRenderFns } from "./SavedMembers.vue?vue&type=template&id=d09da18e&lang=pug"
import script from "./SavedMembers.vue?vue&type=script&lang=js"
export * from "./SavedMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports